import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { DTFService } from "../../dtf.service";
import { AuthorizationService } from "../authorization/authorization.service";
import { WindowRef } from '../../utils/window';

import { APP_CONSTANTS } from '../../utils/app-constants';
import { TranslateUtil } from '../../utils/translate-util';
import { DTFHomepageService } from "../dtfhomepage/dtfhomepage.service";
import { Banner } from "../../shared/models/banner";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatPaginator } from "@angular/material/paginator";
import { MatSelectModule } from "@angular/material/select";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { SharedTranslateModule } from "../../utils/sharedTranslateModule";
import { DynamicLeaseFormComponent } from "../dynamicleaseform/dynamicleaseform.component";
import { MatDialog } from "@angular/material/dialog";
import { ConnectedInsuranceLeadFormComponent } from "../connectedinsuranceleadform/connectedinsuranceleadform.component";

interface Faq {
  question: string;
  answer: string;
  isOpen: boolean;
}


@Component({
    selector: "div.dtf-connectedinsurancelead",
    imports: [SharedTranslateModule,
        MatTableModule, MatCheckboxModule, MatFormFieldModule,
        MatInputModule, FormsModule, MatSelectModule, ReactiveFormsModule, MatButtonToggleModule, ConnectedInsuranceLeadFormComponent, MatSortModule
    ],
    templateUrl: './connectedinsurancelead.component.html',
    providers: [
    //  ClassesUtil, WindowRef
    ]
})
export class ConnectedInsuranceLeadComponent implements OnInit {
  router: Router;
  isCanadaPortal = false;
  currentCountry: string;
  language = '';
  targetRedirect = '';
  usUrl: string;
  caUrl: string;
  toggleOpen: any;
  public alerts: Banner;
  dbData: any;
  question: string;
  answer: string;
  isOpen: boolean;
  isPlaying = false;

   faqs: Faq[] = [
    {
      question: 'What kind of savings can I expect?',
      answer: 'Eligible customers have the opportunity to reduce premiums by up to 10%, excluding fees and taxes, when sharing telematics data.',
      isOpen: false
    },
    {
      question: 'What equipment is eligible for this insurance product?',
      answer: 'Eligible equipment includes both new and used Freightliner® and Western Star® On-Highway and Vocational trucks with an activated Common Telematics Platform (CTP).',
      isOpen: false
    },
    {
      question: 'Do I need new hardware to participate?',
      answer: 'No, if your truck already uses Detroit Connect telematics, you’re ready to participate.',
      isOpen: false
    },
    {
      question: 'What coverages are offered through this program, in partnership with DTIA and GEICO?',
      answer: `We offer coverage for many commercial trucking businesses, providing essential protection to safeguard your customer's investment and ensure peace of mind. In addition to general coverages such as mandatory liability and physical damage coverage, we offer options that are tailored to meet the unique needs of your customers:` +
          `<ul>
            <li>• Non-Trucking Liability</li>
            <li>• Rental Reimbursement with Downtime</li>
            <li>• Motor Truck Cargo Coverage</li>
            <li>• Motor Truck Cargo with Refrigeration Breakdown Coverage</li>
            <li>• Trailer Interchange Coverage</li>
            <li>• Non-Owned Trailer Physical Damage Coverage</li>
            <li>• Motor Truck General Liability Coverage</li>
            <li>• Hired Auto Bodily Injury and Property Damage Coverage</li>
            <li>• Non-Owned Auto Bodily Injury and Property Damage Coverage</li>
            <li>• Additional Insured Endorsement</li>
            <li>• Waiver of Subrogation</li>
          </ul>`,
      isOpen: false
    },
    {
      question: 'Can a customer opt out?',
      answer: 'Yes. The customer can opt out of sharing their data at any time, but doing so may affect their eligibility for the insurance premium discounts.',
      isOpen: false
    }
  ];

  
  constructor(
    router: Router,
    public translate: TranslateService,
    private _window: WindowRef,
    public dtfhomepageService: DTFHomepageService,
    public translateUtil: TranslateUtil
  ) {
    this.router = router;
}
  ngOnInit() {
    const language = (window as any).mbfs.language;
    this.translateUtil.getCurrentCountry().subscribe(val => {
      this.isCanadaPortal = (val === APP_CONSTANTS.COUNTRY_CA) ? true : false;
    });
    this.langInit();
  }

  anouncementMgsopen(e: any) {
    e.preventDefault();
    if (this.toggleOpen) {
      this.toggleOpen = false;
    } else {
      this.toggleOpen = true;
    }
  }

  langInit() {
    // Initializes Language and all URL's for href
    this.language = (this._window.nativeWindow as any).mbfs.language;
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;
  }

  Landingpage(){
     this._window.nativeWindow.location.href = '/home/connected-insurance';
  }

  toggleFaq(index: number) {
    this.faqs = this.faqs.map((faq, i) => ({
      ...faq,
      isOpen: i === index ? !faq.isOpen : false // only one open
    }));
  }



playVideo(video: HTMLVideoElement) {
  if (video.paused) {
    video.play();
  } else {
    video.pause();
  }
}

}
